<template>
	<div class="questionnaire-ckeckbox">
		<div class="questionnaire-title">{{content}}{{score ? `（${score}分）` : ""}}</div>
		<div v-if="!imageList.length" class="questionnaire-options">
			<div :class="`questionnaire-option ${ value && value.indexOf(option.code) > -1 ? 'questionnaire-option-active' : ''}`" v-for="(option, key) in options" :key="key" @click="handleActive(option)">
				<div class="questionnaire-option-icon">
					<img :src="unSelectPng" alt="">
					<img class="questionnaire-option-icon-active" :src="selectPng" alt="">
				</div>
				<div class="questionnaire-option-text">{{option.content}}</div>
			</div>
		</div>

		<div v-else class="questionnaire-options-image">
            <div :class="`questionnaire-option ${value && value.indexOf(option.code) > -1 ? 'questionnaire-option-active' : ''}`" v-for="(option, key) in options" :key="key">
				<div class="questionnaire-option-image">
					<img v-if="option.image" :src="option.image" alt="" @click="handlePreview(key)">
				</div>
				<div class="questionnaire-option-text" @click="handleActive(option)">{{option.content}}</div>
                <div class="questionnaire-option-icon" @click="handleActive(option)">
                    <img :src="unSelectPng" alt="">
                    <img class="questionnaire-option-icon-active" :src="selectPng" alt="">
                </div>
                
            </div>
        </div>
	</div>
</template>

<script>
import selectPng from '@/assets/reserve/questionnaire/select.png'
import unSelectPng from '@/assets/reserve/questionnaire/unSelect.png'
import { ImagePreview } from 'vant';
export default {
	data() {
		return {
			selectPng: selectPng,
			unSelectPng: unSelectPng,
			imageList: []
		}
	},
	model: {
		prop: 'value',
		event: "change"
	},
	props: {
		value: {
			type: Array,
			default: () => {
				return []
			}
		},
		content: {
			type: String,
			default: ""
		},
		options: {
			type: Array,
			default: () => {
				return []
			}
		},
		disabled: {
			type: Boolean,
			default: false
		},
		score: {
			type: String,
			default: ""
		}
	},
	mounted() {
        for (let i = 0; i < this.options.length; i++) {
            const option = this.options[i]
            if (option.image) {
                this.imageList.push(option.image)
            }
		}
    },
	methods: {
		/**
            点击返回按钮的回调事件
            @param { Object }  option 当前的选项
            @return
        */
		handleActive(option) {
			if (this.disabled) {
				return
			}
			if (Array.isArray(this.value)) {
				const value = [...this.value]
				const index = value.indexOf(option.code)
				if (index > -1) {
					value.splice(index, 1)
				} else {
					value.push(option.code)
				}
				this.$emit('change', value)
			} else {
				this.$emit('change', [option.code])
			}
		},

		/**
            点击图片预览时触发
            @param { Number }  optionKey 当前的选项下标
            @return
        */
		handlePreview(optionKey) {
			ImagePreview({
				images: this.imageList,
				startPosition: optionKey
			})
		}
	}
}
</script>

<style lang="scss" scoped>

.questionnaire-options {
    .questionnaire-option {
        display: flex;
        flex-direction: row;
        margin-bottom: 0.16rem;
        .questionnaire-option-icon {
            position: relative;
            padding: 0.07rem 0.16rem 0.07rem 0;
            > img {
                display: block;
                width: 0.28rem;
                height: 0.28rem;
            }
            .questionnaire-option-icon-active {
                z-index: 2;
                position: absolute;
                left: 0;
                top: 0.07rem;
                opacity: 0;
            }
        }
        .questionnaire-option-text {
            margin-left: 0.16rem;
            font-size: 0.3rem;
            line-height: 0.42rem;
            color: #666;
        }
    }
}

.questionnaire-option-active {
    .questionnaire-option-text {
        color: #f86190 !important;
    }
    .questionnaire-option-icon-active {
        opacity: 1 !important;
    }
}

.questionnaire-options-image {
    display: flex;
    flex-direction: row;
	flex-wrap: wrap;
    .questionnaire-option {
        width: 33.33%;
		display: flex;
        flex-direction: column;
        align-items: center;
		
        margin-bottom: 0.16rem;
        .questionnaire-option-icon {
            position: relative;
            padding: 0.08rem;
            > img {
                display: block;
                width: 0.28rem;
                height: 0.28rem;
            }
            .questionnaire-option-icon-active {
                z-index: 2;
                position: absolute;
                left: 0.08rem;
                top: 0.08rem;
                opacity: 0;
            }
        }
        .questionnaire-option-text {
            font-size: 0.3rem;
            line-height: 0.42rem;
			text-align: center;
            color: #666;
			
        }
		.questionnaire-option-image {
			overflow: hidden;
			width: 1.6rem;
			height: 1.6rem;
			margin-bottom: 0.08rem;
			border-radius: 0.48rem;
			background-color: #EFEFEF;
			>img {
				display: block;
				width: 1.6rem;
				height: 1.6rem;
			}
		}
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/reserve/questionnaire/components/checkbox.vue